// @flow

import type { ProductItem, WizardSorting } from '@chatchamp/chatchamp-types'

export const WIZARD_EVENTS = {
  Loaded: 'ChatchampWizardLoaded',
  Started: 'ChatchampWizardStarted',
  Completed: 'ChatchampWizardCompleted',
  RecommendedProductClicked: 'ChatchampWizardRecommendedProductClicked',
  AddedToCartEvent: 'ChatchampWizardAddedToCartEvent',
  RestartedEvent: 'ChatchampWizardRestartedEvent',
  RoutineAddedToCartEvent: 'ChatchampWizardRoutineAddedToCartEvent',
  AttributeMatchingListExpandedEvent: 'ChatchampWizardAttributeMatchingListExpandedEvent',
  RecommendedProductInfoClickedEvent: 'ChatchampWizardRecommendedProductInfoClickedEvent',
  MoreProductsLoadedEvent: 'ChatchampWizardMoreProductsLoadedEvent',
  ProductsSortedEvent: 'ChatchampWizardProductsSortedEvent'
}

export type Wizard$LoadedEventPayload = {
  customerId: string,
  subscriberId: string,
  wizardId: number,
  landingPageId: number
}

export type Wizard$StartedEventPayload = Wizard$LoadedEventPayload

export type Wizard$CompletedEventPayload = {
  customerId: string,
  subscriberId: string,
  wizardId: number,
  productIds: string,
  products: Array<ProductItem>,
  type: 'products_recommended',
  utilityMax: number,
  utilityAverage: number
}

export type Wizard$RecommendedProductClickedEventPayload = {
  customerId: string,
  subscriberId: string,
  wizardId: number,
  productId: string,
  utility: number
}

export type Wizard$AddedToCartEventPayload = {
  customerId: string,
  subscriberId: string,
  wizardId: number,
  product: ProductItem,
  productId: string
}

export type Wizard$RoutineAddedToCartEventPayload = {
  customerId: string,
  subscriberId: string,
  wizardId: number,
  products: Array<ProductItem>,
  productIds: string
}

export type Wizard$AttributeMatchingListExpandedEventPayload = Wizard$RecommendedProductClickedEventPayload

export type Wizard$RecommendedProductInfoClickedEventPayload = Wizard$RecommendedProductClickedEventPayload

export type Wizard$MoreProductsLoadedEventPayload = Wizard$CompletedEventPayload

export type Wizard$ProductsSortedEventPayload = {
  customerId: string,
  subscriberId: string,
  wizardId: number,
  sorting: WizardSorting
}

export type WizardEvent =
  Wizard$ProductsSortedEventPayload
  | Wizard$MoreProductsLoadedEventPayload
  | Wizard$RecommendedProductInfoClickedEventPayload
  | Wizard$AttributeMatchingListExpandedEventPayload
  | Wizard$RoutineAddedToCartEventPayload
  | Wizard$AddedToCartEventPayload
  | Wizard$RecommendedProductClickedEventPayload
  | Wizard$CompletedEventPayload
  | Wizard$StartedEventPayload
  | Wizard$LoadedEventPayload
